export default __webpack_public_path__ + "static/bg_point32.jpg?5e5ad16ce6b3";